const MAX_COMPARE_ITEMS = 3

function cloneSnapshot (task) {
  return JSON.parse(JSON.stringify(task))
}

export default {
  namespaced: true,
  state: {
    compareItems: [],
    comparePreviewOpen: false
  },
  getters: {
    compareItems: state => state.compareItems,
    compareCount: state => state.compareItems.length,
    comparePreviewOpen: state => state.comparePreviewOpen,
    isFull: state => state.compareItems.length >= MAX_COMPARE_ITEMS,
    isInCompare: state => (sessionCompareKey) => {
      return state.compareItems.some(item => item.sessionCompareKey === sessionCompareKey)
    },
    isInCompareByTaskId: state => (taskId) => {
      return state.compareItems.some(item => item.id === taskId || item.task_id === taskId)
    }
  },
  mutations: {
    setComparePreviewOpen (state, open) {
      state.comparePreviewOpen = !!open
    },
    addToCompare (state, { snapshot, sessionCompareKey }) {
      const entry = cloneSnapshot(snapshot)
      entry.sessionCompareKey = sessionCompareKey
      if (!entry.compareEntryId) {
        entry.compareEntryId = 'ce-' + Date.now() + '-' + Math.random().toString(36).slice(2, 9)
      }
      const existingIdx = state.compareItems.findIndex(
        item => item.sessionCompareKey === sessionCompareKey
      )
      if (existingIdx >= 0) {
        state.compareItems.splice(existingIdx, 1, entry)
        return
      }
      if (state.compareItems.length >= MAX_COMPARE_ITEMS) return
      state.compareItems.push(entry)
    },
    removeFromCompare (state, compareEntryId) {
      state.compareItems = state.compareItems.filter(
        item => item.compareEntryId !== compareEntryId
      )
    },
    removeBySessionKey (state, sessionCompareKey) {
      state.compareItems = state.compareItems.filter(
        item => item.sessionCompareKey !== sessionCompareKey
      )
    },
    clearCompare (state) {
      state.compareItems = []
      state.comparePreviewOpen = false
    },
    markAddedToQuote (state, compareEntryId) {
      const item = state.compareItems.find(i => i.compareEntryId === compareEntryId)
      if (item) item.addedToQuote = true
    }
  }
}
